// 提现流程
import { ubtButton } from '@/shared/utils/ubt';
import VueRouter, { Route, RouteConfig } from 'vue-router';
import { RouterV2Enum } from '../router-names';
import { tryBackPathOrHome } from '../utils';

export default (router: VueRouter): RouteConfig[] => ([
  {
    path: RouterV2Enum.applyProduct,
    name: 'applyProduct',
    component: () => import(
      /* webpackChunkName: "draw" */ '@/views_v2/apply-product'
    ),
    meta: {
      title: '提现申请',
      pageId: '臻有钱_提现申请页',
    },
    props: (route) => ({
      commodityId: String(route.query.commodityId || ''),
      // 是否 h5活体 回跳
      h5Bio: Boolean(route.query.h5Bio || ''),
      // h5活体场景 apply 提现 setPwd 设置交易密码 modifyPwd 修改交易密码
      sceneType: String(route.query.sceneType || ''),
      // 优惠券列表跳转提现页面，默认选中优惠券场景
      couponId: String(route.query.couponId || ''),
      // 优惠券列表跳转提现页面，默认选中渠道优惠券场景
      externalCouponId: String(route.query.externalCouponId || ''),
    }),
  },
  {
    path: RouterV2Enum.cardBind,
    name: 'card-bind',
    component: () => import(/* webpackChunkName: "draw-card-bind" */ '@/views_v2/card-bind'),
    props: (route) => ({
      entryFrom: route.query.from || '',
      fromPath: route.query.fromPath || '',
      backPath: route.query.backPath || '',
      commodityId: String(route.query.commodityId || ''),
      userBankId: String(route.query.userBankId || ''),
      capitalCode: String(route.query.capitalCode || ''),
      forwardUrl: String(route.query.forwardUrl || ''),
      loanOrderId: route.query.loanOrderId || '',
      fromHistoryLength: route.query.fromHistoryLength || '',
      isPreCredit: route.query.isPreCredit === 'true',
      ocrAfterLoan: Boolean(route.query.ocrAfterLoan || ''),
    }),
    meta: {
      pageId: 'FinanceH5.CardBind',
      desc: '臻有钱_新增银行卡页',
      title: ' ',
      backConfirmDialog: {
        title: '确定要退出?',
        message: '不绑卡将无法提现哦，确定离开吗？',
        confirmButtonText: '继续绑卡',
        cancelButtonText: '仍要退出',
        beforeConfirm: () => ubtButton(
          '臻有钱_验证银行卡信息页',
          '臻有钱_验证银行卡信息页_继续绑卡',
        ),
        beforeCancel: () => ubtButton(
          '臻有钱_验证银行卡信息页',
          '臻有钱_验证银行卡信息页_残忍离开',
        ),
      },
    },
  },


  {
    path: RouterV2Enum.cardList,
    name: 'card-list',
    component: () => import(/* webpackChunkName: "draw-card-list" */ '@/views_v2/card-list'),
    meta: {
      pageId: '臻有钱_选择银行卡页',
      title: '选择银行卡',
      desc: '选择银行卡',
    },
    props: (route) => ({
      entryFrom: route.query.from || '',
      fromPath: route.query.fromPath || '',
      backPath: route.query.backPath || '',
      forwardUrl: route.query.forwardUrl || '',
      commodityId: String(route.query.commodityId || ''),
      capitalCode: String(route.query.capitalCode || ''),
      loanOrderId: route.query.loanOrderId || '',
      fromHistoryLength: route.query.fromHistoryLength || '',
      isPreCredit: route.query.isPreCredit === 'true',
      ocrAfterLoan: Boolean(route.query.ocrAfterLoan || ''),
    }),
  },

  {
    path: RouterV2Enum.myCoupon,
    name: 'myCoupon',
    component: () => import(/* webpackChunkName: "draw-my-coupon" */ '@/views_v2/my-coupon'),
    meta: {
      pageId: '臻有钱_我的优惠券',
      title: '我的优惠券',
      isShowH5Nav: true,
      navBarCustomProps: {
        textAlign: 'center',
        fontSize: '18px',
      },
    },
  },

  {
    path: RouterV2Enum.selectedCoupon,
    name: 'selectedCoupon',
    component: () => import(/* webpackChunkName: "draw-select-coupon" */ '@/views_v2/select-coupon'),
    meta: {
      pageId: '臻有钱_选择优惠券',
      title: '选择优惠券',
    },
  },

  {
    path: RouterV2Enum.applyResult,
    name: 'applyResult',
    component: () => import(
      /* webpackChunkName: "draw-apply-result" */ '@/views_v2/apply-result'
    ),
    meta: {
      pageId: '臻有钱_提现申请结果',
      title: '提现结果',
      isShowH5Nav: true,
      isControlCoffeeH5Nav: true,
      // navBarCustomProps: {
      //   textAlign: 'center',
      //   fontSize: '18px',
      //   background: 'var(--page-navbar-bg-color, #fde9e5)',
      // },
      backPath: (to: Route) => {
        if (to.path === RouterV2Enum.myApply) {
          return router.go(0);
        }
        return tryBackPathOrHome(RouterV2Enum.myProfile);
      },
    },
    props: (route) => ({
      orderId: String(route.query.orderId || ''),
      commodityId: String(route.query.commodityId || ''),
      commodityName: String(route.query.commodityName || ''),
      financeVipType: route.query.financeVipType || '',
      pricingType: String(route.query.pricingType || ''),
    }),
  },
]);
